import cx from "classnames";
import React from "react";
import styles from "./StandardWidthPage.scss";

export const StandardWidthPage = ({ className, ...props }) => (
  <div className={cx(styles.StandardWidthPage, className)} {...props} />
);
